import type { SyntheticEvent } from "react";

import { Select } from "@mantine/core";

import { LaborStages } from "@/encounters/components/EncounterLabor/types/labor";

const laborStageSelectOptions = Object.entries(LaborStages).map(([value, label]) => ({
  value,
  label,
}));

interface LaborStageSelectFieldProps {
  value: string;
  onChange: (laborStageLoincCode: string) => void;
}

/** Labor stage dropdown for labor flowsheet questionnaire drawers during amend. */
export function LaborStageSelectField({ value, onChange }: LaborStageSelectFieldProps) {
  const stopEvent = (event: SyntheticEvent) => {
    event.stopPropagation();
  };

  const handleLaborStageChange = (nextValue: string | null) => {
    if (nextValue) {
      onChange(nextValue);
    }
  };

  return (
    <div onClick={stopEvent} role="presentation" data-testid="labor-stage-select-wrapper">
      <Select
        size="xs"
        value={value}
        label="Labor stage"
        allowDeselect={false}
        data={laborStageSelectOptions}
        data-testid="labor-stage-select"
        onChange={handleLaborStageChange}
        comboboxProps={{ withinPortal: true }}
      />
    </div>
  );
}
